import { useState, useEffect } from 'react';
import axios from 'axios';
import { toast, Toaster } from 'sonner';
import { LandingCarrusel } from '@/components/LandingCarrusel';
import { LandingMenu } from '@/components/LandingMenu';
import { LandingTestimonios } from '@/components/LandingTestimonios';

const API = process.env.REACT_APP_BACKEND_URL;
const WA = '50254307807';
const AZUL = '#1FA3E8';
const A = 'https://customer-assets-lqy194kg.emergentagent.net/job_social-crm-3/artifacts';

const IMG = {
  logo: `${A}/ckf7btpo_c3217efc-1851-4a8d-8daf-e535de3c5dd6.jpeg`,
  hero: `${A}/ihtyq4ox_IMG_6530.jpeg`,
  gnc: `${A}/2tv4lhog_04936d63-007a-4228-815a-5a06da328a98.jpeg`,
  comercial2: `${A}/hwcsomt6_dbf35d61-9792-4cde-b358-a130d26f2032.jpeg`,
  casaNegra: `${A}/8hturxcz_98a2e703-6a48-48cb-b1b7-65ccc3be66f0.jpeg`,
  aranaClose: `${A}/npz2m2mn_IMG_6520.jpeg`,
  conectorClose: `${A}/6dblx9iq_IMG_6519.jpeg`,
  tecnicos: `${A}/z508mwvo_e736333d-16cb-4c5f-9dba-d4b4d7684103.jpeg`,
};

const CARRUSEL = [
  [`${A}/0tbzuhhe_0d91e18b-e463-4680-b49e-c7caff1e045c.jpeg`, 'Fachada de doble altura en residencia'],
  [`${A}/04tun9op_c1b49a1c-6b79-4c8f-be77-3442db965c42.jpeg`, 'Edificio comercial de 3 niveles'],
  [`${A}/7zt1w0c2_IMG_6538.jpeg`, 'Ventanal panorámico con vista al jardín'],
  [`${A}/06rp8g1p_IMG_6532.jpeg`, 'Fachada flotante con jardín interior'],
  [`${A}/7xl14dhh_IMG_6531.jpeg`, 'Vidrio templado con herrajes de tensión'],
  [`${A}/vy82rbhw_IMG_6516.jpeg`, 'Fachada curva en centro comercial'],
  [`${A}/ikrj21ao_2fa6f308-05b9-45d3-99c1-7c30ca1a4855.jpeg`, 'Franjas de vidrio en residencia moderna'],
  [`${A}/0f2i3key_94ff7c6f-b978-48e4-966a-5475ecd128b2.jpeg`, 'Fachada esquinera de vidrio templado'],
  [`${A}/uexzk81p_f64d69b9-8552-4a40-b7c1-c588e0e1b8f0.jpeg`, 'Doble nivel con vidrio de piso a cielo'],
  [`${A}/je90dxh1_3cff628e-f2dd-4bcd-91e4-ea708feba0a1.jpeg`, 'Fachada corporativa con arañas inox'],
];

const DEPARTAMENTOS = ['Guatemala', 'Sacatepéquez', 'Chimaltenango', 'Escuintla', 'Santa Rosa', 'Sololá', 'Totonicapán', 'Quetzaltenango', 'Suchitepéquez', 'Retalhuleu', 'San Marcos', 'Huehuetenango', 'Quiché', 'Baja Verapaz', 'Alta Verapaz', 'Petén', 'Izabal', 'Zacapa', 'Chiquimula', 'Jalapa', 'Jutiapa', 'El Progreso'];

const waLink = (text) => `https://wa.me/${WA}?text=${encodeURIComponent(text)}`;

const RAZONES = [
  ['4 a 7 veces más fuerte', 'El templado somete el vidrio a un tratamiento térmico que lo hace hasta 7x más resistente que el vidrio común del mismo espesor.'],
  ['Seguro al romperse', 'Si llegara a romperse, se fragmenta en pequeños trozos sin filos peligrosos — no en placas cortantes como el vidrio normal.'],
  ['Resiste impactos y clima', 'Soporta golpes, viento y cambios bruscos de temperatura. Ideal para fachadas expuestas al sol y la lluvia.'],
  ['Estética sin marcos', 'Grandes paños transparentes con herrajes puntuales: tu fachada luce limpia, moderna y llena de luz natural.'],
];

export default function LandingFachadas() {
  const [form, setForm] = useState({ nombre: '', telefono: '', departamento: '', detalles: '' });
  const [sending, setSending] = useState(false);
  const [done, setDone] = useState(null);

  useEffect(() => {
    axios.post(`${API}/api/landing/track`, { producto: 'fachadas_vidrio_templado' }).catch(() => {});
  }, []);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.nombre.trim() || !form.telefono.trim() || !form.departamento) {
      toast.error('Completa tu nombre, teléfono y departamento');
      return;
    }
    try {
      setSending(true);
      const res = await axios.post(`${API}/api/landing/fachadas/lead`, form);
      setDone(res.data);
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'Error enviando, intenta de nuevo');
    } finally { setSending(false); }
  };

  return (
    <div style={{ fontFamily: "'Inter', system-ui, sans-serif" }} className="min-h-screen bg-[#080B10] text-white">
      <Toaster position="top-center" richColors />
      <style>{`@keyframes deslizarX{0%,100%{transform:translateX(0)}50%{transform:translateX(10px)}}`}</style>

      {/* Top bar */}
      <header className="sticky top-0 z-40 bg-[#080B10]/90 backdrop-blur border-b border-white/10">
        <div className="max-w-6xl mx-auto px-4 py-2.5 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img src={IMG.logo} alt="Soluciones Arquitectónicas" className="h-10 sm:h-11 w-auto rounded" data-testid="header-logo" />
            <p className="hidden sm:block text-[10px] text-white/50 tracking-[0.25em] uppercase border-l border-white/15 pl-3">Modernizando ambientes</p>
          </div>
          <div className="flex items-center gap-2">
            <LandingMenu actual="/fachadasvidriotemplado" />
            <a href={waLink('¡Hola! Vi la página de fachadas de vidrio templado y quiero una cotización 😊')}
              target="_blank" rel="noreferrer" data-testid="wa-header-btn"
              className="bg-[#25D366] hover:brightness-110 text-white text-sm font-bold px-4 py-2 rounded-full transition-all">
              WhatsApp
            </a>
          </div>
        </div>
      </header>

      {/* Hero */}
      <section className="relative">
        <img src={IMG.hero} alt="Fachada comercial de vidrio templado" className="w-full h-[64vh] object-cover object-center opacity-70" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#080B10] via-[#080B10]/45 to-[#080B10]/25" />
        <div className="absolute inset-0 flex items-end">
          <div className="max-w-6xl mx-auto px-4 pb-10 w-full">
            <p style={{ color: AZUL }} className="font-bold text-xs tracking-[0.3em] uppercase mb-3">Para comercios, oficinas y residencias</p>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black leading-[1.05] max-w-3xl">
              Fachadas de <span style={{ color: AZUL }}>Vidrio Templado</span>
            </h1>
            <p className="text-white/70 text-base mt-4 max-w-xl">
              Dale a tu negocio o casa una imagen imponente con vidrio templado de 10mm y 12mm, fijado con herrajes y arañas de acero inoxidable 304. Modernizando ambientes.
            </p>
            <div className="flex gap-3 mt-6 flex-wrap">
              <a href="#cotizar" data-testid="hero-cta"
                style={{ background: AZUL }}
                className="hover:brightness-110 text-white font-black px-6 py-3 rounded-full text-sm transition-all">
                COTIZA GRATIS →
              </a>
              <a href={waLink('¡Hola! Quiero cotizar una fachada de vidrio templado 😊')} target="_blank" rel="noreferrer"
                className="border border-white/25 hover:border-white/60 text-white font-bold px-6 py-3 rounded-full text-sm transition-colors">
                Escríbenos por WhatsApp
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Stats strip */}
      <section style={{ background: AZUL }} data-testid="stats-strip">
        <div className="max-w-6xl mx-auto px-4 py-6 grid grid-cols-2 md:grid-cols-4 gap-4 text-center">
          {[
            ['4-7x', 'más resistente que el vidrio común'],
            ['10 y 12mm', 'espesores según tu proyecto'],
            ['Inox 304', 'arañas y herrajes de alta calidad'],
            ['+18 años', 'de experiencia instalando'],
          ].map(([n, t]) => (
            <div key={n}>
              <p className="text-2xl sm:text-3xl font-black leading-none">{n}</p>
              <p className="text-white/90 text-xs sm:text-sm font-medium mt-1">{t}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Por qué elegir vidrio templado */}
      <section className="max-w-6xl mx-auto px-4 py-14" data-testid="seccion-porque">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 items-start">
          <div className="lg:col-span-2 lg:sticky lg:top-24">
            <p style={{ color: AZUL }} className="font-bold text-xs tracking-[0.3em] uppercase mb-3">Seguridad + diseño</p>
            <h2 className="text-2xl sm:text-3xl font-black leading-tight">¿Por qué elegir <span style={{ color: AZUL }}>vidrio templado</span>?</h2>
            <p className="text-white/60 text-base mt-4">
              No todo el vidrio es igual. El vidrio templado pasa por un proceso de calentamiento y enfriamiento controlado que multiplica su resistencia — por eso es el estándar para fachadas comerciales y residenciales de alto nivel.
            </p>
            <a href="#cotizar" style={{ background: AZUL }}
              className="inline-block mt-6 hover:brightness-110 text-white font-black px-6 py-3 rounded-full text-sm transition-all">
              QUIERO MI FACHADA →
            </a>
          </div>
          <div className="lg:col-span-3 grid grid-cols-1 sm:grid-cols-2 gap-4">
            {RAZONES.map(([t, d], i) => (
              <div key={t} className="bg-white/[0.04] border border-white/10 rounded-2xl p-5 hover:border-[#1FA3E8]/40 transition-colors" data-testid={`razon-${i}`}>
                <p style={{ color: AZUL }} className="text-2xl font-black leading-none mb-2">{String(i + 1).padStart(2, '0')}</p>
                <p className="font-black text-sm sm:text-base">{t}</p>
                <p className="text-white/55 text-sm mt-2 leading-relaxed">{d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Espesores + herrajes */}
      <section className="max-w-6xl mx-auto px-4 pb-14" data-testid="seccion-especificaciones">
        <p style={{ color: AZUL }} className="font-bold text-xs tracking-[0.3em] uppercase mb-2 text-center">Materiales de primera</p>
        <h2 className="text-2xl sm:text-3xl font-black text-center mb-2">Espesores y herrajes <span style={{ color: AZUL }}>profesionales</span></h2>
        <p className="text-white/50 text-sm text-center mb-8" data-testid="colores-vidrio">Vidrio templado disponible en <span className="text-white/80 font-bold">claro, bronce y gris</span>.</p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          <div className="bg-white/[0.04] border border-white/10 rounded-3xl p-6">
            <p className="text-4xl font-black" style={{ color: AZUL }}>10<span className="text-lg">mm</span></p>
            <p className="font-black text-base mt-2">Vidrio templado 10mm</p>
            <p className="text-white/55 text-sm mt-2 leading-relaxed">Ideal para fachadas de locales comerciales, divisiones y puertas de vidrio. Excelente relación resistencia-inversión.</p>
          </div>
          <div className="bg-white/[0.04] border border-white/10 rounded-3xl p-6">
            <p className="text-4xl font-black" style={{ color: AZUL }}>12<span className="text-lg">mm</span></p>
            <p className="font-black text-base mt-2">Vidrio templado 12mm</p>
            <p className="text-white/55 text-sm mt-2 leading-relaxed">Para fachadas de gran altura, paños amplios y proyectos que exigen máxima rigidez y seguridad estructural.</p>
          </div>
          <div className="bg-white/[0.04] border border-white/10 rounded-3xl overflow-hidden" data-testid="card-aranas">
            <img src={IMG.aranaClose} alt="Herrajes de acero inoxidable 304 para fachada de vidrio" className="w-full h-44 object-cover object-center" />
            <div className="p-6 pt-4">
              <p className="font-black text-base">Arañas y herrajes Inox 304</p>
              <p className="text-white/55 text-sm mt-2 leading-relaxed">Fijaciones puntuales de acero inoxidable 304: no se oxidan, soportan la intemperie y dejan la fachada visualmente limpia.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Comercios */}
      <section className="max-w-6xl mx-auto px-4 pb-14 grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
        <div>
          <p style={{ color: AZUL }} className="font-bold text-xs tracking-[0.3em] uppercase mb-3">Tu marca merece verse bien</p>
          <h2 className="text-2xl sm:text-3xl font-black leading-tight">Una fachada que <span style={{ color: AZUL }}>vende por ti</span></h2>
          <p className="text-white/60 text-base mt-4">
            La primera impresión de tu negocio es la fachada. Con vidrio templado tus productos se ven desde la calle, entra más luz natural y tu local proyecta la imagen profesional que tus clientes esperan.
          </p>
          <p className="text-white/60 text-base mt-3">
            Trabajamos con centros comerciales, tiendas, oficinas corporativas y residencias en toda Guatemala.
          </p>
          <div className="grid grid-cols-2 gap-3 mt-5">
            <img src={IMG.comercial2} alt="Fachada comercial con puertas de vidrio templado" className="rounded-2xl h-32 w-full object-cover border border-white/10" />
            <img src={IMG.casaNegra} alt="Residencia moderna con franjas de vidrio templado" className="rounded-2xl h-32 w-full object-cover border border-white/10" />
          </div>
        </div>
        <figure className="rounded-3xl overflow-hidden border border-white/10">
          <img src={IMG.gnc} alt="Local GNC con fachada de vidrio templado instalada" className="w-full h-[440px] object-cover object-center" />
        </figure>
      </section>

      {/* Carrusel */}
      <section className="pb-14" data-testid="carrusel-proyectos">
        <div className="max-w-6xl mx-auto px-4 flex items-end justify-between gap-4">
          <div>
            <p style={{ color: AZUL }} className="font-bold text-xs tracking-[0.3em] uppercase mb-2">Proyectos reales</p>
            <h2 className="text-2xl sm:text-3xl font-black mb-6">Inspírate para tu <span style={{ color: AZUL }}>fachada</span></h2>
          </div>
          <p className="text-white/60 text-sm font-bold mb-6 shrink-0 flex items-center gap-1" data-testid="deslizar-hint">
            Deslizar <span style={{ color: AZUL, animation: 'deslizarX 1.2s ease-in-out infinite', display: 'inline-block' }} className="font-black text-lg">→</span>
          </p>
        </div>
        <LandingCarrusel producto="fachadas_vidrio_templado" initial={CARRUSEL.map(([url, caption]) => ({ url, caption }))} />
      </section>

      {/* Instalación profesional + guía PDF */}
      <section className="max-w-6xl mx-auto px-4 pb-14 grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
        <figure className="rounded-3xl overflow-hidden border border-white/10 order-1 md:order-none">
          <img src={IMG.tecnicos} alt="Técnicos instalando vidrio templado con ventosas" className="w-full h-[400px] object-cover object-center" />
        </figure>
        <div>
          <p style={{ color: AZUL }} className="font-bold text-xs tracking-[0.3em] uppercase mb-3">¡Somos Profesionales!</p>
          <h2 className="text-2xl sm:text-3xl font-black leading-tight">Instalación certificada, de principio <span style={{ color: AZUL }}>a fin</span></h2>
          <p className="text-white/60 text-base mt-4">
            Una fachada de vidrio templado exige cálculo, equipo especializado y manos expertas. Nuestro equipo con +18 años de experiencia se encarga de la medición, fabricación e instalación — tú solo disfrutas el resultado.
          </p>
          <div className="bg-white/[0.04] border border-white/10 rounded-2xl p-5 mt-5" data-testid="guia-card">
            <p className="font-black text-sm">📘 Manual de Mantenimiento GRATIS</p>
            <p className="text-white/55 text-sm mt-1.5">
              Al comprar con nosotros recibes el manual para que tu fachada dure décadas. Incluye una advertencia clave: <span className="text-white/80 font-bold">nunca uses limpiavidrios comerciales con químicos o amoníaco</span> — manchan el vidrio y oxidan los herrajes de acero inoxidable.
            </p>
            <a href={`${API}/api/landing/guia-vidrio-templado`} data-testid="guia-download-btn"
              className="inline-block mt-3 border border-[#1FA3E8] text-[#1FA3E8] hover:bg-[#1FA3E8] hover:text-white font-black px-5 py-2.5 rounded-full text-xs transition-colors">
              DESCARGAR MANUAL PDF
            </a>
          </div>
        </div>
      </section>

      {/* Testimonios */}
      <section className="max-w-6xl mx-auto px-4 pb-14" data-testid="seccion-testimonios">
        <p style={{ color: AZUL }} className="font-bold text-xs tracking-[0.3em] uppercase mb-2 text-center">Lo que dicen nuestros clientes</p>
        <h2 className="text-2xl sm:text-3xl font-black text-center mb-8">Clientes que confiaron <span style={{ color: AZUL }}>en nosotros</span></h2>
        <LandingTestimonios producto="fachadas_vidrio_templado" initial={[
            {
              nombre: 'Ricardo Molina',
              texto: 'Remodelamos la fachada de nuestra tienda con vidrio templado de 10mm y las ventas se notan: la gente ve los productos desde afuera y entra. La instalación fue rápida y muy ordenada.',
            },
            {
              nombre: 'Andrea Villagrán',
              texto: 'En la casa queríamos una fachada de doble altura y nos daba miedo el tema de seguridad. Nos explicaron todo sobre el vidrio templado de 12mm y las arañas de acero. Quedó espectacular y nos sentimos seguros.',
            },
            {
              nombre: 'Jorge Soto · Arquitecto',
              texto: 'Como arquitecto he trabajado varias tiendas con ellos. Cumplen fechas, el vidrio y los herrajes son de primera calidad y responden ante cualquier detalle. Un proveedor serio, de los que cuesta encontrar.',
            },
          ]} color={AZUL} />
      </section>

      {/* FAQ */}
      <section className="max-w-3xl mx-auto px-4 pb-14" data-testid="seccion-faq">
        <p style={{ color: AZUL }} className="font-bold text-xs tracking-[0.3em] uppercase mb-2 text-center">Resolvemos tus dudas</p>
        <h2 className="text-2xl sm:text-3xl font-black text-center mb-8">Preguntas <span style={{ color: AZUL }}>frecuentes</span></h2>
        <div className="space-y-3">
          {[
            ['¿Cuánto cuesta una fachada de vidrio templado?',
              'Depende del tamaño, el espesor (10mm o 12mm), el tipo de herrajes y el lugar de instalación. La cotización es GRATIS y sin compromiso — envíanos medidas o fotos por WhatsApp y te respondemos el mismo día.'],
            ['¿Qué diferencia hay entre vidrio de 10mm y 12mm?',
              'Ambos son templados y muy resistentes. El de 10mm es ideal para fachadas de locales y alturas estándar; el de 12mm se usa en paños grandes, dobles alturas y proyectos que exigen máxima rigidez. Te asesoramos según tu proyecto.'],
            ['¿Es seguro el vidrio templado si se rompe?',
              'Sí. A diferencia del vidrio común, el templado se fragmenta en pequeños trozos sin filos cortantes. Además es 4 a 7 veces más resistente, por lo que romperse es muy poco probable.'],
            ['¿Qué son las "arañas" de acero inoxidable?',
              'Son los herrajes puntuales que sujetan los paños de vidrio a la estructura. Usamos acero inoxidable 304, que no se oxida y soporta la intemperie por décadas.'],
            ['¿Cómo empiezo mi proyecto?',
              'Llena el formulario de esta página o escríbenos al WhatsApp 5430-7807. Vamos, medimos, te cotizamos y coordinamos la instalación de principio a fin.'],
          ].map(([q, a], i) => (
            <details key={q} className="group bg-white/[0.04] border border-white/10 rounded-2xl overflow-hidden" data-testid={`faq-item-${i}`}>
              <summary className="flex items-center justify-between gap-4 cursor-pointer px-5 py-4 font-bold text-sm sm:text-base list-none [&::-webkit-details-marker]:hidden hover:bg-white/[0.03] transition-colors">
                {q}
                <span style={{ color: AZUL }} className="text-xl font-black shrink-0 group-open:rotate-45 transition-transform">+</span>
              </summary>
              <p className="px-5 pb-5 text-white/65 text-sm leading-relaxed">{a}</p>
            </details>
          ))}
        </div>
      </section>

      {/* Formulario */}
      <section id="cotizar" className="max-w-2xl mx-auto px-4 pb-16">
        <div className="bg-white/[0.05] border border-white/10 rounded-3xl p-6 sm:p-8">
          {done ? (
            <div className="text-center py-6" data-testid="lead-success">
              <p className="text-5xl mb-4">✅</p>
              <h3 className="text-2xl font-black">¡Recibido, {form.nombre.split(' ')[0]}!</h3>
              <p className="text-white/60 text-sm mt-2 mb-6">Un asesor te contactará muy pronto. Si quieres respuesta inmediata, continúa por WhatsApp:</p>
              <a href={done.wa_link} target="_blank" rel="noreferrer" data-testid="lead-wa-btn"
                className="inline-block bg-[#25D366] hover:brightness-110 text-white font-black px-8 py-3 rounded-full text-sm transition-all">
                💬 Continuar en WhatsApp
              </a>
            </div>
          ) : (
            <>
              <h2 className="text-2xl font-black">Cotiza tu fachada <span style={{ color: AZUL }}>GRATIS</span></h2>
              <p className="text-white/50 text-sm mt-1 mb-6">Sin compromiso. Te contactamos por WhatsApp o llamada.</p>
              <form onSubmit={submit} className="space-y-4">
                <div>
                  <label className="text-xs font-bold text-white/60 uppercase tracking-wide">Tu nombre *</label>
                  <input value={form.nombre} onChange={set('nombre')} data-testid="lead-nombre" placeholder="Ej: Carlos Pérez"
                    className="mt-1 w-full bg-black/30 border border-white/15 focus:border-[#1FA3E8] rounded-xl px-4 py-3 text-sm text-white outline-none transition-colors" />
                </div>
                <div>
                  <label className="text-xs font-bold text-white/60 uppercase tracking-wide">Teléfono / WhatsApp *</label>
                  <input value={form.telefono} onChange={set('telefono')} data-testid="lead-telefono" placeholder="Ej: 5555 5555" inputMode="tel"
                    className="mt-1 w-full bg-black/30 border border-white/15 focus:border-[#1FA3E8] rounded-xl px-4 py-3 text-sm text-white outline-none transition-colors" />
                </div>
                <div>
                  <label className="text-xs font-bold text-white/60 uppercase tracking-wide">¿En qué departamento estás? *</label>
                  <select value={form.departamento} onChange={set('departamento')} data-testid="lead-departamento" style={{ colorScheme: 'dark' }}
                    className="mt-1 w-full bg-black/30 border border-white/15 focus:border-[#1FA3E8] rounded-xl px-4 py-3 text-sm text-white outline-none transition-colors">
                    <option value="">Selecciona…</option>
                    {DEPARTAMENTOS.map((d) => <option key={d} value={d}>{d}</option>)}
                  </select>
                </div>
                <div>
                  <label className="text-xs font-bold text-white/60 uppercase tracking-wide">Detalles de tu proyecto</label>
                  <textarea value={form.detalles} onChange={set('detalles')} data-testid="lead-detalles" rows={3}
                    placeholder="Ej: fachada de local comercial de 6 x 4 metros, vidrio de 10mm…"
                    className="mt-1 w-full bg-black/30 border border-white/15 focus:border-[#1FA3E8] rounded-xl px-4 py-3 text-sm text-white outline-none transition-colors resize-none" />
                </div>
                <button type="submit" disabled={sending} data-testid="lead-submit"
                  style={{ background: AZUL }}
                  className="w-full hover:brightness-110 disabled:opacity-60 text-white font-black py-3.5 rounded-xl text-sm transition-all">
                  {sending ? 'Enviando…' : 'QUIERO MI COTIZACIÓN GRATIS'}
                </button>
              </form>
            </>
          )}
        </div>
      </section>

      {/* Footer */}
      <footer className="border-t border-white/10 py-6 text-center text-xs text-white/40">
        Soluciones Arquitectónicas · Modernizando ambientes · Grupo SACH · Guatemala · WhatsApp +502 5430 7807 · +18 años de experiencia
      </footer>

      {/* WhatsApp flotante */}
      <a href={waLink('¡Hola! Vi la página de fachadas de vidrio templado y quiero una cotización 😊')}
        target="_blank" rel="noreferrer" data-testid="wa-float-btn" aria-label="WhatsApp"
        className="fixed bottom-5 right-5 z-50 bg-[#25D366] hover:scale-110 transition-transform w-14 h-14 rounded-full flex items-center justify-center shadow-2xl">
        <svg viewBox="0 0 32 32" width="30" height="30" fill="#fff"><path d="M16 3C9.4 3 4 8.4 4 15c0 2.1.6 4.2 1.7 6L4 29l8.2-1.6c1.2.6 2.5.9 3.8.9 6.6 0 12-5.4 12-12S22.6 3 16 3zm0 22c-1.2 0-2.4-.3-3.5-.8l-.6-.3-4.9 1 1-4.7-.3-.6C6.6 18.1 6 16.6 6 15 6 9.5 10.5 5 16 5s10 4.5 10 10-4.5 10-10 10zm5.5-7.5c-.3-.2-1.8-.9-2-1-.3-.1-.5-.2-.7.2-.2.3-.8 1-.9 1.1-.2.2-.3.2-.6.1-.3-.2-1.3-.5-2.4-1.5-.9-.8-1.5-1.8-1.7-2.1-.2-.3 0-.5.1-.6l.5-.5c.2-.2.2-.3.3-.5.1-.2 0-.4 0-.6l-1-2.3c-.2-.6-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4-.3.3-1 1-1 2.5s1.1 2.9 1.2 3.1c.2.2 2.1 3.2 5.1 4.5.7.3 1.3.5 1.7.6.7.2 1.4.2 1.9.1.6-.1 1.8-.7 2-1.4.3-.7.3-1.3.2-1.4-.1-.1-.3-.2-.6-.4z"/></svg>
      </a>
    </div>
  );
}
